/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) System Send Icon component.
 */
export const SystemSendIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M5.9241 20.4834C5.55538 20.6895 5.09421 20.3729 5.15442 19.9548C5.41165 18.1684 5.91521 14.6269 6.16583 13.2333C6.17115 13.2038 6.18023 13.1807 6.20773 13.1687C6.58239 13.005 9.94008 12.1917 11.706 11.757C12.1243 11.654 12.1222 11.3268 11.7032 11.2266C9.82684 10.7781 6.18902 9.89769 6.1735 9.80906C5.89306 8.29593 5.39821 4.80187 5.15292 3.04615C5.09447 2.62782 5.56208 2.31032 5.9308 2.51638L21.2191 11.0602C21.5605 11.251 21.5606 11.7422 21.2192 11.9331L5.9241 20.4834Z' fill={iconColor} />
    </svg>
  );
};

export default SystemSendIcon;
